import { render, staticRenderFns } from "./ADQindex.vue?vue&type=template&id=32c6b79b&scoped=true"
import script from "./ADQindex.vue?vue&type=script&lang=js"
export * from "./ADQindex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c6b79b",
  null
  
)

export default component.exports